import React, { useState } from 'react';
import { Modal, Box, Typography, Button, TextField } from '@mui/material';
import { toast } from 'react-toastify';

const CancelRequestModal = ({ open, onClose, bondDetails, refreshHandler }) => {
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleInputChange = (event) => {
    setMessage(event.target.value);
  };

  const handleCancelRequest = async () => {
    if (message.trim() === '') {
      toast.error('Please provide a reason for cancellation.');
      return;
    }

    setLoading(true);
    const token = localStorage.getItem('jwtToken');
    const baseURL = process.env.REACT_APP_BASE_URL;
    try {
      const response = await fetch(`${baseURL}RequestingTransferBond/${bondDetails.transferBondTransactionID}/cancelRequest`, {
        method: 'PATCH',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(message),
      });

      if (!response.ok) {
        throw new Error(`Error canceling the request: ${response.statusText}`);
      }
      refreshHandler(); // Refresh the bond details after success
      toast.success('Request canceled successfully.');
      onClose(); // Close the modal after success
    } catch (error) {
      toast.error('Error canceling the request.');
      console.error('Error canceling the request:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="cancel-request-modal">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography id="cancel-request-modal" variant="h6" gutterBottom>
          Please provide a brief reason for cancellation
        </Typography>
        <TextField
          fullWidth
          label="Reason"
          variant="outlined"
          multiline
          rows={3}
          inputProps={{ maxLength: 80 }}
          value={message}
          onChange={handleInputChange}
          disabled={loading}
        />
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button variant="outlined" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button variant="contained" color="secondary" onClick={handleCancelRequest} disabled={loading}>
            Submit
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default CancelRequestModal;
